import axios from "axios";
import { config } from "../../api-helper/api-header-configs";
const baseURL = process.env.REACT_APP_API_URL;

// Create Tag
export const create_tag = async (values: any) => {
    const payload = {
        tag_title: values.tag_title,
        description: values.description || '',
        status: values.status || '1'
    };
    const response = await axios.post(baseURL + "/tags", payload, config);
    return response.data;
}

// List All Tags
export const get_all_tags = async () => {
    const response = await axios.get(baseURL + "/tags", {
        params: {
            _t: Date.now() // Cache busting
        }
    });
    return response.data;
}

// Get Single Tag
export const get_tag_by_id = async (id: string) => {
    const response = await axios.get(baseURL + `/tags/${id}`, config);
    return response.data;
}

// Update Tag
export const update_tag = async (id: string, values: any) => {
    const payload = {
        tag_title: values.tag_title,
        description: values.description || '',
        status: values.status || '1'
    };
    const response = await axios.patch(baseURL + `/tags/${id}`, payload, config);
    return response.data;
}

// Delete Tag
export const delete_tag = async (id: string) => {
    const response = await axios.delete(baseURL + `/tags/${id}`, config);
    return response.data;
}

